export * from './photos.component';
